import React, { Fragment, useCallback, useState } from 'react';
import PropTypes from 'prop-types';

import {
  adaptDateToLocalTimezone,
  isNewDayInList,
} from '../../../../utils/converters/dateConverters';
import MessageSeparatorView from '../../../Chat/components/MessageSeparatorView';
import { ReportItem } from '../ReportItem';
import Popup from '../../../common/Popup';
import ReportDetails from '../ReportDetails';
import { enhance } from './enhance';
import Loader from '../../../common/Loader';
import { isDesktop } from '../../../../utils/mobileHelpers';

const ReportsListImpl = ({
  intl: { formatMessage },
  fetchComplaint,
  resetDetails,
  resolveLoading,
  details,
  loading,
  resolve,
  list,
}) => {
  const [isShowPopup, togglePopup] = useState(false);

  const openDetailsModal = useCallback(id => {
    fetchComplaint({ id });
    togglePopup(true);
  }, []);

  const closeDetailsModal = useCallback(() => {
    togglePopup(false);
    resetDetails();
  }, []);

  const handleResolve = useCallback((data, closeModal) => {
    resolve(data);
    return closeModal && closeDetailsModal();
  }, []);

  return (
    <div styleName="root">
      {resolveLoading && <Loader styleName="loading" />}

      {list.map((item, index) => {
        const isNewDay = isNewDayInList(list, index);

        return (
          <Fragment key={item.id}>
            {isNewDay && (
              <MessageSeparatorView
                date={adaptDateToLocalTimezone(item.createdAt)}
                hasBorder
                left
              />
            )}
            <ReportItem
              item={item}
              onClick={() => openDetailsModal(item.id)}
              formatMessage={formatMessage}
            />
          </Fragment>
        );
      })}
      <Popup
        onClose={closeDetailsModal}
        opened={isShowPopup}
        width={isDesktop() ? 'postCommunity' : 'medium'}
        title={formatMessage({ id: 'reports.details' })}
      >
        <ReportDetails
          report={details}
          loading={loading}
          onResolve={handleResolve}
        />
      </Popup>
    </div>
  );
};

export const ReportsList = enhance(ReportsListImpl);

const propTypes = {
  list: PropTypes.array.isRequired,
};
ReportsListImpl.propTypes = {
  details: PropTypes.object.isRequired,
  loading: PropTypes.bool.isRequired,
  resolveLoading: PropTypes.bool.isRequired,
  resolve: PropTypes.func.isRequired,
  ...propTypes,
};
ReportsList.propTypes = propTypes;



// WEBPACK FOOTER //
// ./src/components/Communities/Reports/ReportsList/index.jsx